import { TraitRegistryCategory } from '../../../registry/trait/TraitRegistryCategory';
export class TraitRegistryDraft extends TraitRegistryCategory {
    label = 'Draft';
}
